import { TimestampEntity } from 'src/app/timer/state/timer.interface';
import { dayKeyFor } from './day-key.utils';

/**
 * Partitions a batch of entries by the logical day each one's OWN timestamp belongs to
 * (`dayKeyFor`), de-duplicating by entry id within each resulting bucket and sorting each bucket
 * chronologically.
 *
 * Pure and total: no store access, no app state. Used by `HistoryRepairService.repair()`, the
 * one-time local migration that partitions every stored entry across every stored day.
 */
export function partitionEntriesByDay(
  entries: TimestampEntity[],
  dayStartHour: number,
): Map<string, TimestampEntity[]> {
  const byDay = new Map<string, Map<number, TimestampEntity>>();
  for (const entry of entries) {
    const key = dayKeyFor(entry.timestamp, dayStartHour);
    const bucket = byDay.get(key) ?? new Map<number, TimestampEntity>();
    bucket.set(entry.id, entry);
    byDay.set(key, bucket);
  }

  const result = new Map<string, TimestampEntity[]>();
  for (const [key, bucket] of byDay) {
    result.set(key, sortByTimestamp([...bucket.values()]));
  }
  return result;
}

function sortByTimestamp(entries: TimestampEntity[]): TimestampEntity[] {
  return [...entries].sort(
    (a, b) => new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime(),
  );
}
